import answeringMachine from '../images/bots/answering machine.svg';
import beauty from '../images/bots/beauty.svg';
import demoBot from '../images/bots/demo bot.svg';
import eLearning from '../images/bots/e-learning.svg';
import entertainment from '../images/bots/entertainment.svg';
import foodDelivery from '../images/bots/food delivery.svg';
import internetShopping from '../images/bots/internet shoping.svg';
import leadGeneration from '../images/bots/lead generation.svg';
import poll from '../images/bots/poll.svg';
import privateClub from '../images/bots/private club.svg';
import question from '../images/bots/question.svg';
import realEstate from '../images/bots/real estate.svg';
import settingUp from '../images/icons/video settingup.svg';
import mailing from '../images/icons/video mailing.svg';
import schemes from '../images/icons/video schemes.svg';

export const pages = [
	{ id: '1', title: "Yandex", link: "https://yandex.com/" },
	{ id: '2', title: "Yandex", link: "https://yandex.com/" },
	{ id: '3', title: "Yandex", link: "https://yandex.com/" },
	]

const descPlug = 'Бот ответит стандартным сообщением на запрос от человека. Подходит для всех мессенджеров. Шаблон возможно изменить под ваши цели.'

export const templates = [
	{ id: '1', name: "Бот автоответчик", icon: answeringMachine, keyName: 'answeringMachine', desc: descPlug },
  { id: '2', name: "Доставка еды", icon: foodDelivery, keyName: 'foodDelivery', desc: descPlug },
  { id: '3', name: "Демо бот", icon: demoBot, keyName: 'demoBot', desc: descPlug },
	{ id: '4', name: "Опрос", icon: poll, keyName: 'poll', desc: descPlug },
  { id: '5', name: "Лидогенерация/HR решения", icon: leadGeneration, keyName: 'leadGeneration', desc: descPlug },
  { id: '6', name: "Онлайн школа/Вебинар", icon: eLearning, keyName: 'eLearning', desc: descPlug },
	{ id: '7', name: "Закрытый клуб по подписке", icon: privateClub, keyName: 'privateClub', desc: descPlug },
  { id: '8', name: "Агенство по недвижимости", icon: realEstate, keyName: 'realEstate', desc: descPlug },
  { id: '9', name: "Развлечения", icon: entertainment, keyName: 'entertainment', desc: descPlug },
	{ id: '10', name: "Салон красоты", icon: beauty, keyName: 'beauty', desc: descPlug },
  { id: '11', name: "Онлайн-покупки", icon: internetShopping, keyName: 'internetShopping', desc: descPlug },
  { id: '12', name: "Вопрос/ответ", icon: question, keyName: 'question', desc: descPlug },
]

export const mailings = [
  { id: '22496346',
    name: "№1",
    messenger: "Telegram",
    sent: "8",
    conversion: "60",
    status: "started",
  },
  { id: '32284427',
    name: "№2",
    messenger: "Viber",
    sent: "1",
    conversion: "0",
    status: "stopped",
  },
  { id: '65390710',
    name: "№3",
    messenger: "Vk",
    sent: "16",
    conversion: "82",
    status: "started",
  },
]

export const bots = [
	{ id: '1', name: "Салон красоты", type: "telegram" },
	{ id: '2', name: "Запись клиентов для консультации", type: "telegram" },
	{ id: '3', name: "Опрос клиентов для проведения встречи", type: "telegram" },
	]

export	const videos = [
	{ id: '1', title: "Подключение и основные параметры", image: settingUp, video: "https://www.youtube.com/embed/lVFj91Z1AfM" },
	{ id: '2', title: "Настраиваем простую рассылку", image: mailing, video: "https://www.youtube.com/embed/lVFj91Z1AfM" },
	{ id: '3', title: "Начало работы с блок-схемами", image: schemes, video: "https://www.youtube.com/embed/lVFj91Z1AfM" },
]

export const countries = [
  'Афганистан',
  'Албания',
  'Антарктика',
  'Алжир',
  'Американское Самоа',
  'Андора',
  'Ангола',
  'Антигуа и Барбуда',
  'Азербайджан',
  'Аргентина',
  'Австралия',
  'Австрия',
  'Багамские Острова',
  'Бахрейн',
  'Бангладеш',
  'Армения',
  'Барбадос',
  'Бельгия',
  'Бермудские Острова',
  'Бутан',
  'Боливия',
  'Босния и Герцеговина',
  'Ботсвана',
  'Остров Буве',
  'Бразилия',
  'Белиз',
  'Британская территория в Индийском океане',
  'Соломоновы Острова',
  'Британские Виргинские острова',
  'Бруней',
  'Болгария',
  'Мьянма',
  'Бурунди',
  'Белоруссия',
  'Камбоджа',
  'Камерун',
  'Канада',
  'Кабо-Верде',
  'Каймановы острова',
  'Центральноафриканская Республика',
  'Шри-Ланка',
  'Чад',
  'Чили',
  'Китайская Народная Республика',
  'Остров Рождества',
  'Кокосовые острова',
  'Колумбия',
  'Коморы',
  'Майотта',
  'Республика Конго',
  'Демократическая Республика Конго',
  'Острова Кука',
  'Коста-Рика',
  'Хорватия',
  'Куба',
  'Кипр',
  'Чехия',
  'Бенин',
  'Дания',
  'Доминика',
  'Доминиканская Республика',
  'Эквадор',
  'Сальвадор',
  'Экваториальная Гвинея',
  'Эфиопия',
  'Эритрея',
  'Эстония',
  'Фарерские острова',
  'Фолклендские острова',
  'Южная Георгия и Южные Сандвичевы острова',
  'Фиджи',
  'Финляндия',
  'Аландские острова',
  'Франция',
  'Французская Гвиана',
  'Французская Полинезия',
  'Французские Южные и Антарктические территории',
  'Джибути',
  'Габон',
  'Грузия',
  'Гамбия',
  'Палестина',
  'Германия',
  'Гана',
  'Гибралтар',
  'Кирибати',
  'Греция',
  'Гренландия',
  'Гренада',
  'Гваделупа',
  'Гуам',
  'Гватемала',
  'Гвинея',
  'Гайана',
  'Республика Гаити',
  'Остров Херд и острова Макдональд',
  'Ватикан',
  'Гондурас',
  'Гонконг',
  'Венгрия',
  'Исландия',
  'Индия',
  'Индонезия',
  'Иран',
  'Ирак',
  'Ирландия',
  'Израиль',
  'Италия',
  'Кот-д’Ивуар',
  'Ямайка',
  'Япония',
  'Казахстан',
  'Иордания',
  'Кения',
  'КНДР',
  'Республика Корея',
  'Кувейт',
  'Киргизия',
  'Лаос',
  'Ливан',
  'Лесото',
  'Латвия',
  'Либерия',
  'Ливия',
  'Лихтенштейн',
  'Литва',
  'Люксембург',
  'Макао',
  'Мадагаскар',
  'Малави',
  'Малайзия',
  'Мальдивы',
  'Мали',
  'Мальта',
  'Мартиника',
  'Мавритания',
  'Маврикий',
  'Мексика',
  'Монако',
  'Монголия',
  'Молдавия',
  'Черногория',
  'Монтсеррат',
  'Марокко',
  'Мозамбик',
  'Оман',
  'Намибия',
  'Науру',
  'Непал',
  'Нидерланды',
  'Кюрасао',
  'Аруба',
  'Синт-Мартен',
  'Бонэйр, Синт-Эстатиус и Саба',
  'Новая Каледония',
  'Вануату',
  'Новая Зеландия',
  'Никарагуа',
  'Нигер',
  'Нигерия',
  'Ниуэ',
  'Норфолк',
  'Норвегия',
  'Северные Марианские острова',
  'Внешние малые острова США',
  'Микронезия',
  'Маршалловы Острова',
  'Палау',
  'Пакистан',
  'Панама',
  'Папуа — Новая Гвинея',
  'Парагвай',
  'Перу',
  'Филиппины',
  'Острова Питкэрн',
  'Польша',
  'Португалия',
  'Гвинея-Бисау',
  'Восточный Тимор',
  'Пуэрто-Рико',
  'Катар',
  'Реюньон',
  'Румыния',
  'Россия',
  'Руанда',
  'Сен-Бартелеми',
  'Острова Святой Елены, Вознесения и Тристан-да-Кунья',
  'Сент-Китс и Невис',
  'Ангилья',
  'Сент-Люсия',
  'Сен-Мартен (Франция)',
  'Сен-Пьер и Микелон',
  'Сент-Винсент и Гренадины',
  'Сан-Марино',
  'Сан-Томе и Принсипи',
  'Саудовская Аравия',
  'Сенегал',
  'Сербия',
  'Сейшельские Острова',
  'Сьерра-Леоне',
  'Сингапур',
  'Словакия',
  'Словения',
  'Сомали',
  'Южно-Африканская Республика',
  'Зимбабве',
  'Испания',
  'Южный Судан',
  'Судан',
  'Западная Сахара',
  'Суринам',
  'Шпицберген и Ян-Майен',
  'Свазиленд',
  'Швеция',
  'Швейцария',
  'Сирия',
  'Таджикистан',
  'Таиланд',
  'Того',
  'Токелау',
  'Тонга',
  'Тринидад и Тобаго',
  'Объединённые Арабские Эмираты',
  'Тунис',
  'Турция',
  'Туркмения',
  'Теркс и Кайкос',
  'Тувалу',
  'Уганда',
  'Украина',
  'Республика Македония',
  'Египет',
  'Великобритания',
  'Гернси',
  'Джерси',
  'Остров Мэн',
  'Танзания',
  'Соединённые Штаты Америки',
  'Виргинские Острова',
  'Буркина-Фасо',
  'Уругвай',
  'Узбекистан',
  'Венесуэла',
  'Уоллис и Футуна',
  'Самоа',
  'Йемен',
  'Замбия',
];
